import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import LinkTranslated from '@components/shared/LinkTranslated';
import { P } from '@components/shared/Typography';
import { BREAKPOINT } from '@constants';
import Arrow from '@images/right-arrow.svg';
import { getArticleInfo, getCategoryColour } from '@prismicVitals';
import useNavigate from '@utils/useNavigate';

interface Props {
  currentArticleIndex: any;
  totalNumberOfArticles: any;
}

export default function ArticleNextPrevButtons({ currentArticleIndex, totalNumberOfArticles }: Props) {
  const { navigateWrapper } = useNavigate();
  const [allArticleInfo, setArticleInfo] = useState<any[]>();
  const [previousArticleCatColour, setPreviousArticleCatColour] = useState<any>();
  const [nextArticleCatColour, setNextArticleCatColour] = useState<any>();
  const [previousArticle, setPreviousArticle] = useState<any>();
  const [nextArticle, setNextArticle] = useState<any>();

  useEffect(() => {
    getArticleInfo(setArticleInfo);
  }, []);

  useEffect(() => {
    if (allArticleInfo) {
      getPreviousArticle();
      getNextArticle();
    }
  }, [allArticleInfo]);

  const getPreviousArticle = () => {
    let previousArticleIndex = null;
    let previousArticleTemp = null;
    if (currentArticleIndex > 0) {
      previousArticleIndex = currentArticleIndex - 1;
      previousArticleTemp = allArticleInfo[currentArticleIndex - 1];
      setPreviousArticle(previousArticleTemp);
      getCategoryColour(setPreviousArticleCatColour, previousArticleTemp.data.category);
    } else {
      previousArticleIndex = totalNumberOfArticles - 1;
      previousArticleTemp = allArticleInfo[previousArticleIndex];
      setPreviousArticle(previousArticleTemp);
      getCategoryColour(setPreviousArticleCatColour, previousArticleTemp.data.category);
    }
  };

  const getNextArticle = () => {
    let nextArticleIndex = null;
    let nextArticleTemp = null;
    if (currentArticleIndex < totalNumberOfArticles) {
      nextArticleIndex = currentArticleIndex + 1;
      nextArticleTemp = allArticleInfo[nextArticleIndex];
      setNextArticle(nextArticleTemp);
      getCategoryColour(setNextArticleCatColour, nextArticleTemp.data.category);
    } else {
      nextArticleIndex = 0;
      nextArticleTemp = allArticleInfo[nextArticleIndex];
      setNextArticle(nextArticleTemp);
      getCategoryColour(setNextArticleCatColour, nextArticleTemp.data.category);
    }
  };

  const handlePrevClick = () => {
    navigateWrapper(`/vitals/${previousArticle.data.category.uid}/${previousArticle.uid}/`);
  };

  const handleNextClick = () => {
    navigateWrapper(`/vitals/${nextArticle.data.category.uid}/${nextArticle.uid}/`);
  };

  return (
    <Container>
      {previousArticle && (
        <StyledPreviousLink
          onClick={handlePrevClick}
          bgcolor={previousArticleCatColour}
          to={`/vitals/${previousArticle.data.category.uid}/${previousArticle.uid}/`}
        >
          <StyledPrev>
            <StyledArrowPrev />
            Previous Article
          </StyledPrev>
          <TextWrapper>
            <H3Styled>{previousArticle.data.title}</H3Styled>
          </TextWrapper>
        </StyledPreviousLink>
      )}
      {nextArticle && (
        <StyledNextLink onClick={handleNextClick} bgcolor={nextArticleCatColour} to={`/vitals/${nextArticle.data.category.uid}/${nextArticle.uid}/`}>
          <StyledNext>
            Next Article <StyledArrow />
          </StyledNext>

          <H3Styled>{nextArticle.data.title}</H3Styled>
        </StyledNextLink>
      )}
    </Container>
  );
}

interface StyledPreviousLinkProps {
  bgcolor: any;
}

interface StyledNextLinkProps {
  bgcolor: any;
}

const Container = styled.div`
  width: 100%;
  display: flex;
  border-top: 2px solid #003b1b;
  /* justify-content: space-around; */
  @media only screen and (max-width: ${BREAKPOINT.mobileL}px) {
    width: 100%;
  }
`;

const StyledArrow = styled(Arrow)`
  margin-left: 10px;
`;
const StyledArrowPrev = styled(Arrow)`
  transform: rotate(-180deg);
  margin-right: 10px;
`;

const StyledLinkContainer = styled(LinkTranslated)<StyledPreviousLinkProps>`
  background-color: ${({ bgcolor }) => bgcolor};
  border-right: none;
  padding: 30px 35px;
  width: 50%;
  text-decoration: none;

  &:hover {
    text-decoration: none;
    & svg {
      transition: margin ease-out 0.3s;
      margin-right: 20px;
    }
  }
  @media only screen and (max-width: ${BREAKPOINT.tablet}px) {
    padding: 20px;
  }
`;

const StyledPreviousLink = styled(StyledLinkContainer)`
  text-align: right;
`;

const StyledNextLink = styled(StyledLinkContainer)<StyledNextLinkProps>`
  text-align: left;
  border-left: black solid 2px;
`;

const StyledPrev = styled(P)`
  font-family: 'Domaine';
  font-size: 14px;
  font-weight: normal;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const StyledNext = styled(P)`
  font-family: 'Domaine';
  font-size: 14px;
  font-weight: normal;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
`;

const H3Styled = styled(P)`
  font-size: 20px;
  max-width: 350px;
  @media only screen and (max-width: ${BREAKPOINT.tablet}px) {
    font-size: 15px;
  }
`;
const TextWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;
